import UserInfo from './UserInfo.view';

export default UserInfo;
